/* Crystal Drops page script. Runs only on the vf-crystal-drops template. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('gc-config');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  document.body.classList.add('gc-page');

  var root = document.getElementById('gc-root');
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- state ---------- */
  var state = { variant: CFG.defaultVariant, qty: 1, addons: {} };
  var variantById = {};
  CFG.variants.forEach(function (v) { variantById[v.id] = v; });

  function total() {
    var v = variantById[state.variant];
    var t = v.price * state.qty;
    CFG.addons.forEach(function (a) { if (state.addons[a.id]) t += a.price; });
    return t;
  }

  function render() {
    var v = variantById[state.variant];
    $$('.gc-tree').forEach(function (b) {
      var on = String(b.dataset.variant) === String(state.variant);
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var now = $('[data-gc-price]'); if (now) now.textContent = money(v.price * state.qty);
    var was = $('[data-gc-was]'); var save = $('[data-gc-save]');
    if (v.compare && v.compare > v.price) {
      if (was) { was.hidden = false; was.textContent = money(v.compare * state.qty); }
      if (save) { save.hidden = false; save.textContent = 'Save ' + money((v.compare - v.price) * state.qty); }
    } else { if (was) was.hidden = true; if (save) save.hidden = true; }
    var out = $('[data-gc-qty]'); if (out) out.textContent = state.qty;
    $$('.gc-addon').forEach(function (b) { b.setAttribute('aria-pressed', state.addons[b.dataset.addon] ? 'true' : 'false'); });
    $$('[data-gc-kit]').forEach(function (b) {
      var on = !!state.addons[b.dataset.gcKit];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.textContent = on ? b.dataset.labelOn : b.dataset.labelOff;
    });
    $$('[data-gc-total]').forEach(function (el) { el.textContent = money(total()); });
    $$('[data-gc-sticky-name]').forEach(function (el) { el.textContent = v.short + (state.qty > 1 ? ' x ' + state.qty : ''); });
    var vi = $('input[name="id"][data-gc-variant-input]'); if (vi) vi.value = state.variant;
  }

  $$('.gc-tree').forEach(function (b) {
    b.addEventListener('click', function () { state.variant = Number(b.dataset.variant); render(); });
  });
  $$('[data-gc-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.qty = Math.max(1, Math.min(10, state.qty + Number(b.dataset.gcStep))); render();
    });
  });
  $$('.gc-addon').forEach(function (b) {
    b.addEventListener('click', function () { state.addons[b.dataset.addon] = !state.addons[b.dataset.addon]; render(); });
  });
  $$('[data-gc-kit]').forEach(function (b) {
    b.addEventListener('click', function () { state.addons[b.dataset.gcKit] = !state.addons[b.dataset.gcKit]; render(); });
  });

  /* ---------- cart ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() { var d = drawer(); return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : []; }
  function setCount(n) {
    $$('[data-gc-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function fetchCart() { return fetch(CFG.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(path, body) {
    return fetch(CFG.routes.root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.text().then(function (t) { var j; try { j = JSON.parse(t); } catch (e) { throw new Error(CFG.strings.error); } if (!r.ok || j.status) throw new Error(j.description || j.message || CFG.strings.error); return j; }); });
  }
  function paintDrawer(j, open, btn) {
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function') { if (open) window.location.href = CFG.routes.cart; return; }
    if (j && j.sections) d.renderContents(j);
    if (typeof j.item_count === 'number') d.classList.toggle('is-empty', j.item_count === 0);
    if (open && typeof d.open === 'function' && !d.classList.contains('active')) d.open(btn);
  }
  /* the VIP sheet (when the store shows one) opens first; keep the drawer hidden for a moment so they do not fight */
  function vipFirst() {
    var sheet = document.querySelector('.vf-root'), bag = drawer();
    if (!sheet || !bag || sheet.classList.contains('open')) return;
    var hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
    Object.keys(hide).forEach(function (k) { bag.style.setProperty(k, hide[k], 'important'); });
    var ticks = 0, tm = setInterval(function () {
      if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach(function (k) { bag.style.removeProperty(k); }); }
    }, 100);
  }

  /* free gifts follow the drops: one gift set and the gift code while drops are in the cart, none without them */
  var syncing = null;
  function syncGifts() {
    if (syncing) return syncing;
    syncing = fetchCart().then(function (cart) {
      var hasMain = cart.items.some(function (i) { return i.product_id === CFG.productId; });
      var code = (CFG.giftCode || '').toUpperCase();
      var codes = (cart.discount_codes || []).map(function (c) { return c.code; });
      var others = codes.filter(function (c) { return c.toUpperCase() !== code; });
      var hasCode = codes.length !== others.length;
      var updates = {}, change = false;
      if (hasMain) {
        CFG.gifts.forEach(function (g) {
          var lines = cart.items.filter(function (i) { return i.variant_id === g.id; });
          if (!lines.length) { updates[g.id] = 1; change = true; }
          lines.forEach(function (l, k) { var want = k === 0 ? 1 : 0; if (l.quantity !== want) { updates[l.key] = want; change = true; } });
        });
      } else {
        var giftIds = CFG.gifts.map(function (g) { return g.id; });
        cart.items.forEach(function (i) { if (giftIds.indexOf(i.variant_id) > -1 || (i.properties && i.properties._gift === 'crystal-drops')) { updates[i.key] = 0; change = true; } });
      }
      var wantCode = hasMain && code;
      if (!change && (wantCode ? hasCode : !hasCode)) { setCount(cart.item_count); return cart; }
      var body = { updates: updates, sections: sectionIds(), sections_url: window.location.pathname };
      body.discount = others.concat(wantCode ? [CFG.giftCode] : []).join(',');
      return post('cart/update.js', body).then(function (j) { paintDrawer(j, false); setCount(j.item_count); return j; });
    }).catch(function () { return null; }).then(function (c) { syncing = null; return c; });
    return syncing;
  }

  function addToCart(btn) {
    var errs = $$('[data-gc-error]');
    errs.forEach(function (e) { e.hidden = true; });
    var buttons = $$('[data-gc-add]');
    buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    return fetchCart().then(function (cart) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
      var items = [{ id: state.variant, quantity: state.qty }];
      CFG.addons.forEach(function (a) { if (state.addons[a.id]) items.push({ id: a.id, quantity: 1 }); });
      CFG.gifts.forEach(function (g) { if (!inCart[g.id]) items.push({ id: g.id, quantity: 1, properties: { _gift: 'crystal-drops' } }); });
      var d = drawer();
      if (d && d.setActiveElement) d.setActiveElement(btn);
      return fetch(CFG.routes.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sectionIds(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
    }).then(function (res) {
      if (!res.ok || res.body.status) {
        throw new Error(res.body.description || res.body.message || CFG.strings.error);
      }
      vipFirst();
      paintDrawer(res.body, false);
      return syncGifts().then(function (c) {
        return (c && typeof c.item_count === 'number' ? Promise.resolve(c) : fetchCart()).then(function (cc) {
          setCount(cc.item_count);
          paintDrawer({ item_count: cc.item_count }, true, btn);
        });
      });
    }).catch(function (e) {
      var msg = (e && e.message) ? e.message : CFG.strings.error;
      errs.forEach(function (el) { el.textContent = msg; el.hidden = false; });
    }).then(function () {
      buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
    });
  }
  $$('[data-gc-add]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); addToCart(b); });
  });
  $$('[data-gc-open-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var d = drawer();
      if (!d || typeof d.open !== 'function') return;
      e.preventDefault();
      Promise.all([fetch(CFG.routes.root + '?sections=' + sectionIds().join(',')).then(function (r) { return r.json(); }), fetchCart()]).then(function (res) {
        d.renderContents({ id: 0, sections: res[0] });
        paintDrawer({ item_count: res[1].item_count }, true, b);
      }).catch(function () { d.open(b); });
    });
  });
  syncGifts();
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { clearTimeout(window.__gcSync); window.__gcSync = setTimeout(syncGifts, 300); });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('cart-remove-button, .quantity__button')) setTimeout(syncGifts, 1400);
  });
  /* make sure the gift code is on the cart before checkout */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-drawer [name="checkout"], cart-drawer a[href$="/checkout"]');
    if (!b || b.dataset.gcReady === '1') return;
    e.preventDefault(); e.stopImmediatePropagation();
    syncGifts().then(function () { var n = document.querySelector('cart-drawer [name="checkout"]') || b; n.dataset.gcReady = '1'; n.click(); delete n.dataset.gcReady; });
  }, true);
  /* the shared reviews row puts a comma between the two names; this page joins them with a space */
  $$('.gc-buy__proofrow .ceyla-rproof__text').forEach(function (p) {
    Array.prototype.forEach.call(p.childNodes, function (n) { if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' '; });
  });

  /* ---------- gallery ---------- */
  var track = $('.gc-gallery__track');
  if (track) {
    var slides = $$('.gc-gallery__slide', track);
    var thumbs = $$('.gc-thumb');
    var current = 0;
    var go = function (i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduced ? 'smooth' : 'auto' });
    };
    var mark = function (i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var t = thumbs[i];
      if (t && t.parentNode) {
        var p = t.parentNode;
        var left = t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2;
        p.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
      }
      slides.forEach(function (s, k) {
        var v = s.querySelector('video');
        if (!v) return;
        if (k === i) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); }
      });
    };
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) mark(i);
        ticking = false;
      });
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i, true); mark(i); }); });
    var prev = $('.gc-gallery__nav--prev'), next = $('.gc-gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    mark(0);
  }

  /* ---------- shipping dates (local calendar days) ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function fmtRange(a, b) { return a.getMonth() === b.getMonth() ? fmt(a) + '-' + b.getDate() : fmt(a) + ' - ' + fmt(b); }
  var lastDay = '';
  function dates() {
    var now = new Date();
    var key = now.toDateString();
    if (key === lastDay) return; lastDay = key;
    var s = CFG.ship;
    var shipped = addDays(now, s.ship), d1 = addDays(now, s.min), d2 = addDays(now, s.max);
    $$('[data-gc-date="order"]').forEach(function (el) { el.textContent = fmt(now); });
    $$('[data-gc-date="ship"]').forEach(function (el) { el.textContent = fmt(shipped); });
    $$('[data-gc-date="deliver"]').forEach(function (el) { el.textContent = fmtRange(d1, d2); });
    /* gift deadline: last order day whose latest delivery still lands by Dec 24 */
    var dl = $('[data-gc-deadline]');
    if (dl) {
      var y = now.getFullYear();
      var eve = new Date(y, 11, 24);
      var last = addDays(eve, -s.max);
      if (now <= last) {
        dl.hidden = false;
        var t = dl.querySelector('[data-gc-deadline-date]'); if (t) t.textContent = fmt(last);
      } else { dl.hidden = true; }
    }
  }
  dates();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) dates(); });
  window.addEventListener('pageshow', dates);
  setInterval(dates, 60000);

  /* ---------- dialog ---------- */
  $$('[data-gc-dialog]').forEach(function (b) {
    b.addEventListener('click', function () {
      var dlg = document.getElementById(b.dataset.gcDialog);
      if (dlg && dlg.showModal) dlg.showModal();
    });
  });
  $$('.gc-dialog').forEach(function (dlg) {
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    var x = dlg.querySelector('.gc-dialog__x'); if (x) x.addEventListener('click', function () { dlg.close(); });
  });

  /* ---------- sticky bar and sample pill ---------- */
  var mainAtc = $('.gc-atc');
  var sticky = $('.gc-sticky');
  var closeSec = $('.gc-close');
  if (mainAtc && sticky && 'IntersectionObserver' in window) {
    var atcVisible = true, closeVisible = false;
    var upd = function () { sticky.classList.toggle('is-on', !atcVisible && !closeVisible && mainAtc.getBoundingClientRect().top < 0); };
    new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting; upd(); }).observe(mainAtc);
    if (closeSec) new IntersectionObserver(function (en) { closeVisible = en[0].isIntersecting; upd(); }).observe(closeSec);
  }
  var banner = $('.gc-disclose'), pill = $('.gc-pill');
  if (banner && pill && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { pill.classList.toggle('is-on', !en[0].isIntersecting); }).observe(banner);
  }

  /* ---------- lights off / on comparison ---------- */
  $$('.gc-compare').forEach(function (c) {
    var input = c.querySelector('input');
    var set = function (v) { c.style.setProperty('--pos', v + '%'); };
    if (input) { input.addEventListener('input', function () { set(input.value); }); set(input.value); }
    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        var start = null, from = 88, to = Number(input ? input.value : 50);
        var step = function (ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / 1400), e = 1 - Math.pow(1 - p, 3);
          set(from + (to - from) * e);
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }, { threshold: .5 });
      io.observe(c);
    }
  });

  /* ---------- fit checker ---------- */
  var fit = $('.gc-fit');
  if (fit) {
    var opts = $$('.gc-fit__opt', fit);
    var img = $('.gc-fit__stage img', fit);
    var choose = function (o) {
      opts.forEach(function (x) { x.setAttribute('aria-pressed', x === o ? 'true' : 'false'); });
      if (img) img.style.transform = 'scale(' + o.dataset.scale + ')';
      $('[data-fit-h]', fit).textContent = o.dataset.h;
      $('[data-fit-count]', fit).textContent = o.dataset.count;
      $('[data-fit-note]', fit).textContent = o.dataset.note;
      $('[data-fit-cta]', fit).textContent = o.dataset.cta;
      fit.dataset.variant = o.dataset.variant; fit.dataset.qty = o.dataset.qty;
    };
    opts.forEach(function (o) { o.addEventListener('click', function () { choose(o); }); });
    var pre = opts.filter(function (o) { return o.getAttribute('aria-pressed') === 'true'; })[0] || opts[1] || opts[0];
    if (pre) choose(pre);
    var cta = $('[data-fit-cta]', fit);
    if (cta) cta.addEventListener('click', function () {
      state.variant = Number(fit.dataset.variant); state.qty = Number(fit.dataset.qty) || 1; render();
      var box = document.getElementById('gc-offer');
      if (box) box.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    });
  }
  $$('[data-gc-select]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.variant = Number(b.dataset.gcSelect); render();
      var box = document.getElementById('gc-offer');
      if (box) box.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    });
  });

  /* ---------- reveals (content stays visible without JS) ---------- */
  if (!reduced && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('gc-js');
    var rio = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); rio.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.gc-reveal').forEach(function (el) { rio.observe(el); });
    setTimeout(function () { $$('.gc-reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 6000);
  }

  render();
})();
